import React from 'react';

export default class FormField extends React.Component {

	static contextTypes = {
		form: React.PropTypes.object
	};

	getElement() {
		return this.refs.control;
	}

	render() {
		const control = this.context.form.getControl(this.props.name);
		if (!control) {
			throw new Error('Field `'+this.props.name+'` not found');
		}
		return React.cloneElement(control, {ref: 'control'});
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-forms/src/FormField.js